import { rangeDateType, Option } from 'utils/customTypes';
import { RangeFilter } from './types/filters';

export function isDateRangeFilter(value: any): value is RangeFilter {
  return typeof value === 'object' && ('from' in value || 'to' in value);
}

export function isArrayOfOptions(value: any): value is Option[] {
  return (
    Array.isArray(value) &&
    value.every(
      (item) =>
        typeof item === 'object' &&
        item !== null &&
        'label' in item &&
        'value' in item
    )
  );
}

export function isDateRangeObject(value: any): value is rangeDateType {
  return (
    typeof value === 'object' && ('startDate' in value || 'endDate' in value)
  );
}

export function isFilterValueIsOfStringType(value: any): value is string {
  return typeof value === 'string';
}

export function isBooleanFilter(value: any): value is boolean {
  return typeof value === 'boolean';
}
